function impactSlider() {
    const $slideshow = $('.impact-slideshow__wrapper .impact-slideshow');

    if($slideshow.length > 0) {
        $slideshow.each(function() { 
            $(this).slick({
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: 'unslick'
                    }
                ]
            });
        });
    }
}

$(document).ready(function() {
    impactSlider();

    $(document).on('click', '.next-slide-btn', function(e) {
        e.preventDefault();
        $(this).parents('.impact-slideshow__wrapper .impact-slideshow').slick('slickGoTo', 1, false);
    });

    $(document).on('click', '.open-modal-btn', function(e) {
        e.preventDefault();
        $(this).parents('.impact-slideshow__wrapper').find('.impact-slideshow.hero').addClass('open-modal');
        $(this).parents('.impact-slideshow__wrapper').find('[data-close-impact-modal]').addClass('view-close');
        $('html,body,.main-content').addClass('overflow-hidden');
    });

    $(document).on('click', '[data-close-impact-modal]', function(e) {
        e.preventDefault();
        $(this).removeClass('view-close');
        $(this).parents('.impact-slideshow__wrapper').find('.impact-slideshow.hero').removeClass('open-modal');
        $('html,body,.main-content').removeClass('overflow-hidden');
        var $promoStrip = $('.announcement-bar');
        const promoStripHeight = $promoStrip.length ? $promoStrip.outerHeight(true) : 0;
        $('.header-bg').css({ 'padding-top': promoStripHeight });
        $('.main-content').css({ 'margin-top': promoStripHeight });
    });
});

$(window).resize(function() {
    impactSlider();
});